import $ from 'jquery';

let $form, action;

const setForm = $el => {
    $form = $el;
    action = $form.attr('action');
}

const bindCategoryFilters = target => {
    let $trigger = $form.find(target);

    if ($trigger.length) {
        $trigger.on('click', function (event) {
            event.preventDefault();

            let $selectedCategories = $form.find('[name="_category[]"]:checked');
            let url = action;
            let queryArgs = [];

            if ($selectedCategories.length) {
                for (let i = 0, l = $selectedCategories.length; i < l; i++) {
                    queryArgs.push($selectedCategories[i].value);
                }

                url += `?_categories=${queryArgs.join(',')}`;
            }

            sendUserToFilteredPage(url, queryArgs.length > 0);
        });
    }
};

const bindDateFilter = target => {
    let $trigger = $form.find(target);

    if ($trigger.length) {
        $trigger.on('change', function () {
            let date = $(this).val();

            sendUserToFilteredPage(`${action}?_m=${date}`);
        });
    }
};

const bindMobileFilter = target => {
    let $trigger = $form.find(target);

    if ($trigger.length) {
        $trigger.on('click', function () {
            $trigger.siblings('.bindMobileFilter-wrap').addClass('open').show();
        });

        $(document).on('click', function (event) {
            let $target = $(event.target);

            if (
                !$target.parents().hasClass('mobile-wrap') &&
                !$target.hasClass('mobile-wrap') &&
                !$target.hasClass(target.replace('.', '')) &&
                $(window).width() <= 1024
            ) {
                $trigger.siblings('.mobile-wrap').removeClass('open').hide();
            }
        });
    }
};

const setPageScrollPosition = el => {
    if (window.location.search && window.location.search.indexOf('?') > -1) {
        $('html, body').animate({ scrollTop: $(el).offset().top });
    }
};

const sendUserToFilteredPage = (url, useSeparator) => {
    if (typeof useSeparator === 'undefined') {
        useSeparator = true;
    }

    if (window.location.search && window.location.search.indexOf('archived') > -1) {
        url += (useSeparator ? '&' : '?') + 'archived';
    }

    window.location = url;
}

export {
    setForm,
    bindCategoryFilters,
    bindDateFilter,
    bindMobileFilter,
    setPageScrollPosition
};



// WEBPACK FOOTER //
// ./resources/assets/js/views/Events.js